import { AccountNote } from '@/redux/modules/billingManagement/accountNote/accountNote.types';
import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { getAuthToken } from '@/redux/modules/user';
import { getDeployment } from '@/redux/modules/config';
import { postAccountNote } from '@/redux/modules/billingManagement/accountNote/accountNote.api';

export const saveAccountNote = createAsyncThunk<
    AccountNote,
    Omit<Parameters<typeof postAccountNote>[0], 'authToken' | 'deployment'>
>('la/ui/accountNote/saveAccountNote', async (body, { getState }) => {
    const state = getState();
    const authToken = getAuthToken(state);
    const deployment = getDeployment(state);

    const { payload } = await postAccountNote({
        ...body,
        authToken,
        deployment,
    });
    return payload;
});
